import { ReactElement } from 'react'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/meta'
import PageBuilder from '@/components/layout/builder'
import Layout from '@/components/layout/layout'
import HomeHero from '@/components/sections/home-hero'
import { mapPageStaticProps } from '@/utils/page-data'
import { getPromiseFromFetch } from '@/utils/request'
import { MOCK_DATA } from '@/constants'

import { WPPageData } from '@/types'

export default function Home(
  pageProps: InferGetStaticPropsType<typeof getStaticProps>
) {
  return <PageBuilder pageProps={pageProps} />
}

Home.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={pageProps} />
      <HomeHero pageProps={pageProps} />
      {page}
    </Layout>
  )
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const locale = context.locale || 'en'
  const defaultLocale = context.defaultLocale || 'en'
  const fetchHome = (lang: string) =>
    getPromiseFromFetch<WPPageData>({
      method: 'get',
      url: `/${lang !== defaultLocale ? `${lang}/` : ''}`
    })

  const { data: pageProps } = MOCK_DATA
    ? { data: require(`@/data/pages/home.json`) }
    : await fetchHome(locale)

  // la home tradotta puo' arrivare senza hero (campi ACF non tradotti in WPML): fallback alla lingua di default
  if (
    !MOCK_DATA &&
    locale !== defaultLocale &&
    !(pageProps?.acf as any)?.hero
  ) {
    const { data: fallback } = await fetchHome(defaultLocale)

    pageProps.acf = {
      ...pageProps.acf,
      hero: (fallback?.acf as any)?.hero
    } as typeof pageProps.acf
  }

  return {
    props: {
      ...(await mapPageStaticProps(pageProps))
    }
  }
}
